export const DASHBOARD_VIEW = [
  '1040',
];

export const PROFILE_VIEW = [
  '1050',
  '1051',
];

export const CHANGE_PASSWORD = [
  '1050',
  '1052',
];

export const SERVICE_NAME_WRITE = [
  '1062',
];

export const ADMINISTRATORS_VIEW = [
  '1070',
  '1071',
];

export const ADMINISTRATORS_WRITE = [
  '1070',
  '1072',
];

export const OUTGOING_CALLS_VIEW = [
  '1080',
  '1081',
];

export const KAKAO_PROFILES_VIEW = [
  '1090',
  '1091',
];

export const REJECTION_NUMBERS_VIEW = [
  '1100',
  '1101',
];

export const UNSUBSCRIBE_CUSTOMERS_VIEW = [
  '1110',
  '1111',
];

export const UNSUBSCRIBE_CUSTOMERS_WRITE = [
  '1110',
  '1112',
];

export const DEPARTMENTS_VIEW = [
  '1120',
  '1121',
];

export const DEPARTMENTS_WRITE = [
  '1120',
  '1122',
];

export const CHARGE_VIEW = [
  '1130',
  '1131',
];

export const JOURNEYS_VIEW = [
  '1140',
  '1141',
  '1240',
  '1241',
];

export const KAKAO_TEMPLATES_VIEW = [
  '1150',
  '1151',
];

export const KAKAO_TEMPLATES_WRITE = [
  '1150',
  '1152',
];

export const KAKAO_TEMPLATES_INSPECTION = [
  '1150',
  '1162',
];

export const IMAGES_VIEW = [
  '1170',
  '1171',
  '1180',
  '1181',
  '1190',
  '1191',
];

export const TEXTMESSAGE_IMAGE_VIEW = [
  '1190',
  '1191',
];

export const TEXTMESSAGE_IMAGE_WRITE = [
  '1190',
  '1192',
];

export const FRIENDTALK_IMAGE_VIEW = [
  '1180',
  '1181',
];

export const FRIENDTALK_IMAGE_WRITE = [
  '1180',
  '1182',
];

export const ALIMTALK_IMAGE_VIEW = [
  '1170',
  '1171',
];

export const ALIMTALK_IMAGE_WRITE = [
  '1170',
  '1172',
];

export const EXCEL_VIEW = [
  '1200',
];

export const EXCEL_WRITE = [
  '1200',
];

export const LOGOUT = [
  '1220',
];

export const BRANDTALK_IMAGE_VIEW = [
  '1230',
  '1231',
];

export const BRANDTALK_IMAGE_WRITE = [
  '1230',
  '1232',
];
